import React, { useEffect, useRef, useState } from 'react';

export default function ScrollReveal({ 
  children, 
  className = '', 
  delay = 0, 
  threshold = 0.1,
  animation = 'fade-up' 
}) {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          if (ref.current) {
            observer.unobserve(ref.current);
          }
        }
      },
      { threshold }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(ref.current);
      }
    };
  }, [threshold]);

  const getTransform = () => {
    if (isVisible) return 'translate(0, 0) scale(1)';
    switch (animation) {
      case 'fade-left':
        return 'translateX(-40px) scale(1)';
      case 'fade-right':
        return 'translateX(40px) scale(1)';
      case 'zoom-in':
        return 'translate(0, 0) scale(0.94)';
      case 'fade-up':
      default:
        return 'translateY(40px) scale(1)';
    }
  };

  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: isVisible ? 1 : 0,
        transform: getTransform(),
        transition: `opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1) ${delay}ms, transform 0.8s cubic-bezier(0.16, 1, 0.3, 1) ${delay}ms`,
        width: '100%',
        willChange: 'transform, opacity'
      }}
    >
      {children}
    </div>
  );
}
